/**
 * Regra de cubagem dos itens de orçamento/pedido.
 *
 * A planilha de vendas calcula o m³ de cada linha como
 *
 *     m³ = (C × L × A) / n  ×  (Quant. + Bonif. + Troca)
 *
 * onde C, L e A são as medidas em METROS de um bloco de n caixas empilhadas
 * (n varia de 1 a 20 conforme o produto). O resultado de (C × L × A) / n é o m³
 * de UMA caixa, e é esse número que fica em produto.fatorcx.
 *
 * Como o n não existe no cadastro, fatorcx é a fonte da verdade: compr/larg/altu
 * descrevem o bloco medido, não a caixa, e só entram como último recurso para
 * produto que nunca recebeu cubagem.
 *
 * Mantido em sincronia com App\Services\CubagemService no backend, que é quem
 * grava cubunt/cubtot do item.
 */

/**
 * m³ de uma caixa do produto, a partir do retorno de /api/prodcod.
 */
export function fatorCaixa(produto) {
  if (!produto) {
    return 0;
  }

  const fatorcx = parseFloat(produto.fatorcx) || 0;

  if (fatorcx > 0) {
    return fatorcx;
  }

  const compr = parseFloat(produto.compr) || 0;
  const larg = parseFloat(produto.larg) || 0;
  const altu = parseFloat(produto.altu) || 0;

  if (compr <= 0 || larg <= 0 || altu <= 0) {
    return 0;
  }

  return (compr / 100) * (larg / 100) * (altu / 100);
}

/**
 * Cubagem unitária e total de um item.
 */
export function cubagemItem(produto, qtd) {
  const cubunt = fatorCaixa(produto);

  return {
    cubunt,
    cubtot: cubunt * (parseFloat(qtd) || 0),
  };
}
